module.exports = __webpack_public_path__ + "assets/img/dayu_online_ask.df15f821.png";